import { useLayoutEffect, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "./auth/useAuth";
import ApiAppInit from "./app/api/admin/system/ApiAppInit";
import ApiAuth from "./app/api/public/system/ApiAuth";
import {
    setNodes, setDeviceTypes, setDeviceStatuses, setNodeStatuses, setProxies, setDeviceProxyStatuses,
    setDeviceHealthStatuses, setProxyGroups, setNodeIps, setDeviceProxyModes,
} from "./app/reducers/option/actions";

// За минуту до истечения access-токена — упреждающий refresh.
const REFRESH_BEFORE_EXPIRATION = 60;

// Бутстрап приложения после логина: справочники app-init → state.option
// и таймер упреждающего обновления токена по expAccessToken.
export default function AppInit({ children }) {
    const dispatch = useDispatch();
    const { isAuthReady, isAuthenticated } = useAuth();
    const expAccessToken = useSelector((state) => state.app.expAccessToken);
    const optionNodes = useSelector((state) => state.option.nodes);
    const optionDeviceTypes = useSelector((state) => state.option.deviceTypes);
    const isLoadingRef = useRef(false);

    // Справочники: один раз, только если ещё пусты
    const isOptionsEmpty = Object.keys(optionNodes).length === 0 && Object.keys(optionDeviceTypes).length === 0;
    useLayoutEffect(() => {
        if (!isAuthReady || !isAuthenticated || !isOptionsEmpty || isLoadingRef.current) return;
        isLoadingRef.current = true;
        (async () => {
            const api = ApiAppInit.Index();
            const data = await api.getResponse();
            isLoadingRef.current = false;
            if (!data) return;
            if ('nodes' in data) dispatch(setNodes(data.nodes));
            if ('device_types' in data) dispatch(setDeviceTypes(data.device_types));
            if ('device_statuses' in data) dispatch(setDeviceStatuses(data.device_statuses));
            if ('node_statuses' in data) dispatch(setNodeStatuses(data.node_statuses));
            if ('proxies' in data) dispatch(setProxies(data.proxies));
            if ('device_proxy_statuses' in data) dispatch(setDeviceProxyStatuses(data.device_proxy_statuses));
            if ('device_health_statuses' in data) dispatch(setDeviceHealthStatuses(data.device_health_statuses));
            if ('proxy_groups' in data) dispatch(setProxyGroups(data.proxy_groups));
            if ('node_ips' in data) dispatch(setNodeIps(data.node_ips));
            if ('device_proxy_modes' in data) dispatch(setDeviceProxyModes(data.device_proxy_modes));
        })();
    }, [isAuthReady, isAuthenticated, isOptionsEmpty, dispatch]);

    // Таймер refresh: срабатывает за REFRESH_BEFORE_EXPIRATION до exp
    useEffect(() => {
        if (!isAuthenticated || !expAccessToken) return undefined;
        const delay = Math.max((expAccessToken - REFRESH_BEFORE_EXPIRATION) * 1000 - Date.now(), 0);
        const timer = setTimeout(() => { ApiAuth.RefreshToken(); }, delay);
        return () => clearTimeout(timer);
    }, [isAuthenticated, expAccessToken]);

    return children;
}
